import Vue from 'vue'
import Router from 'vue-router'
import store from '../store/store'
import { hostRouter } from './router-host' // 主办路由
import { exhibitionRouter } from './router-exhibition' // 展商路由
import { exhibitionRouterEn } from './router-exhibitionEn' // 展商路由 - 英文
import { exRegisterRouter } from './router-ex-register' // 健身展商注册地址
import { mobileRouter } from './router-mobile' //
const originalPush = Router.prototype.push
Router.prototype.push = function push(location) {
  return originalPush.call(this, location)
  // .catch(err => err)
}

Vue.use(Router)

const router = new Router({
  mode: 'history',
  routes: [
    { path: '/', redirect: 'exhibition', name: 'exhibition' },
    ...exRegisterRouter,
    ...hostRouter,
    ...exhibitionRouter,
    ...exhibitionRouterEn,
    ...mobileRouter
  ]
})

// 路由守卫
router.beforeEach((to, form, next) => {
  if (to.meta && to.meta.requireAuth === false) {
    // 判断该路由是否需要登录权限 false 为不需要登录
    next()
  } else {
    if (store.state.token) {
      next()
    } else {
      if (to.path.indexOf('exhibitionEn') !== -1) {
        next({ path: '/exhibitionEn/login/alogin' })
      } else if (to.path.indexOf('host') !== -1) {
        next({ path: '/host/login/alogin' })
      } else {
        next({ path: '/exhibition/login/alogin' })
      }
    }
  }
  next()
})

router.beforeEach((to, form, next) => {
  next()
})
export default router
